import Papa from "papaparse";

export type CsvRow = Record<string, string | number>;

/** Builds a CSV from `rows` in `columnOrder` and hands it to the browser as a download. */
export function exportToCsv(filename: string, rows: CsvRow[], columnOrder: string[]) {
    const csv = Papa.unparse(rows, { columns: columnOrder });
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    if (link.download === undefined) return;

    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
